export default __webpack_public_path__ + "static/media/icon-pedagio.6ac8207e.svg";